import { z } from 'zod'
import { MARKER_COLORS, MAX_MARKER_LABEL } from './constants'
import { LAYOUT_IDS } from './layouts'

const time = z.number().finite().int().min(0)
const id = z.string().min(1).max(200)
export const editOp = z.discriminatedUnion('op', [
  z.object({ op: z.literal('autoLayout') }).strict(),
  z.object({ op: z.literal('split'), t: time }).strict(),
  z.object({ op: z.literal('cut'), from: time, to: time }).strict().refine((v) => v.to - v.from >= 100, 'A cut must span at least 100 ms'),
  z.object({ op: z.literal('updateBoundary'), boundaryId: id.optional(), at: time.optional(),
    layout: z.enum(LAYOUT_IDS).optional(), slots: z.array(id).max(9).refine((v) => new Set(v).size === v.length, 'Duplicate slots').optional(), cut: z.boolean().optional(),
  }).strict().refine((v) => (v.boundaryId !== undefined) !== (v.at !== undefined), 'Use exactly one of boundaryId or at')
    .refine((v) => v.layout !== undefined || v.slots !== undefined || v.cut !== undefined, 'Supply a boundary change'),
  z.object({ op: z.literal('addMarker'), t: time, label: z.string().max(MAX_MARKER_LABEL), color: z.enum(MARKER_COLORS) }).strict(),
  z.object({ op: z.literal('setAudio'), sourceId: id, gainDb: z.number().finite().min(-30).max(12).optional(), muted: z.boolean().optional() })
    .strict().refine((v) => v.gainDb !== undefined || v.muted !== undefined, 'Supply an audio change'),
])
export type EditOp = z.infer<typeof editOp>
export const editBatchBody = z.object({
  ops: z.array(editOp).min(1).max(200).refine((ops) => ops.every((op, i) => op.op !== 'autoLayout' || i === 0), 'autoLayout must be the first operation'),
  dryRun: z.boolean().optional(),
  note: z.string().max(1000).optional(),
}).strict()
export type EditBatchBody = z.infer<typeof editBatchBody>
